
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planning-ahead",
      function () {
        return require("private-next-pages/planning-ahead.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planning-ahead"])
      });
    }
  